import { AHText } from "arkh";
import React, { useMemo } from "react";
import { DateTime, ToRelativeUnit } from "luxon";
import { FormattedMessage } from "react-intl";
import { useTimeZone } from "../../../OS/Timezone";

export function FillingText(props: {
  startAt: string;
  freq?: "DAILY" | "WEEKLY" | "MONTHLY" | "YEARLY";
  filled?: boolean;
}) {
  const freq = props.freq ?? "DAILY";

  const unit: ToRelativeUnit | undefined = useMemo(() => {
    switch (freq) {
      case "DAILY":
        return "days";
      case "WEEKLY":
        return "weeks";
      case "MONTHLY":
        return "months";
      case "YEARLY":
        return "years";
    }
  }, [freq]);

  const tz = useTimeZone();
  return (
    <AHText numberOfLines={1} type="detail">
      {props.filled ? (
        ""
      ) : (
        <FormattedMessage
          values={{
            relativeTime: DateTime.fromISO(props.startAt)
              .setZone(tz)
              .toRelativeCalendar({
                unit,
              }),
          }}
          description="Team KPI enter value description"
          defaultMessage="Enter value for {relativeTime}"
        />
      )}
    </AHText>
  );
}
